<script setup>
import { ref } from "vue";
import { apiQuery } from "@/api/j24api";

const license = ref("");
const loading = ref(false);
const gotResult = ref(false);
const decoded = ref("");

async function decodeLicense() {
  if (!license.value) {
    return;
  }
  let result = await apiQuery("ELA", "licences", {
    type: "Elevate",
    apiAction: "DecodeLicence",
    licence: license.value,
  });
  if (result.licence) {
    // Replace | with new lines for better readability
    decoded.value = result.licence.replace(/\|/g, "\n");
    gotResult.value = true;
  }
  loading.value = false;
}
</script>

<template>
  <v-row>
    <v-col>
      <h1>Decode License</h1>
    </v-col>
  </v-row>
  <template v-if="!gotResult">
    <v-row>
      <v-col>
        <v-textarea
          v-model="license"
          label="Paste License Key Here"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="decodeLicense()" :loading="loading">
          Decode License
        </v-btn>
      </v-col>
    </v-row>
  </template>
  <template v-else>
    <v-row>
      <v-col>
        <h2>Decoded License Result</h2>
        <v-textarea
          v-model="decoded"
          label="Decoded License"
          readonly
          rows="10"
        >
        </v-textarea>
      </v-col>
    </v-row>
  </template>
</template>
